import { Component, Input } from "@angular/core";
import {
    ESGMatrixScope,
    ESGMatrixScopeData,
    GetESGMatrixResponse,
    ESGScopeDataType,
} from "../../../../WebApiClient";

@Component({
    selector: "app-sustainability-esg-matrix-scope",
    templateUrl: "./matrix-scope.component.html",
    styleUrls: ["./matrix-scope.component.scss"],
    standalone: false,
})
export class SustainabilityMatrixScopeComponent {
    @Input() esgMatrixData: GetESGMatrixResponse;
    @Input() scopeNumber: number;

    constructor() {
        this.esgMatrixData = {} as GetESGMatrixResponse;
        this.scopeNumber = -1;
    }

    getScopeData(): ESGMatrixScope | undefined {
        if (!this.esgMatrixData.scopes) {
            return undefined;
        }

        let scope = this.esgMatrixData.scopes.find(
            (c) => c.number === this.scopeNumber
        );

        return scope;
    }

    getEnergyProcessesValue(scopeData: ESGMatrixScopeData): number {
        return this.getScopeDataValue(
            scopeData,
            ESGScopeDataType.EnergyProcesses
        );
    }
    getProcurementValue(scopeData: ESGMatrixScopeData): number {
        return this.getScopeDataValue(scopeData, ESGScopeDataType.Procurement);
    }
    getTransportValue(scopeData: ESGMatrixScopeData): number {
        return this.getScopeDataValue(scopeData, ESGScopeDataType.Transport);
    }
    getSoldProductsValue(scopeData: ESGMatrixScopeData): number {
        return this.getScopeDataValue(scopeData, ESGScopeDataType.SoldProducts);
    }
    getWasteRecyclingValue(scopeData: ESGMatrixScopeData): number {
        return this.getScopeDataValue(
            scopeData,
            ESGScopeDataType.WasteRecycling
        );
    }
    private getScopeDataValue(
        scopeData: ESGMatrixScopeData,
        dataType: ESGScopeDataType
    ): number {
        let scopeDataValue = scopeData.scopeDataValues?.find(
            (c) => c.esgScopeDataType === dataType
        );
        if (scopeDataValue) {
            return scopeDataValue.value ?? 0;
        }
        return 0;
    }
}
